<template>
  <v-card
    :href="recall.recallSheetUrl ?? undefined"
    target="_blank"
    rel="noopener noreferrer"
    rounded="lg"
    hover
  >
    <div class="d-flex" style="height: 120px">
      <v-img
        v-if="imageUrl"
        :src="imageUrl"
        width="100"
        min-width="100"
        max-width="100"
        height="120"
        cover
        class="rounded-s-lg flex-grow-0"
      />
      <div
        v-else
        class="d-flex align-center justify-center bg-grey-lighten-3 rounded-s-lg flex-shrink-0"
        style="width: 100px; height: 120px"
      >
        <v-icon size="40" color="grey">mdi-package-variant</v-icon>
      </div>

      <div class="d-flex flex-column flex-grow-1 pa-3" style="min-width: 0">
        <div class="d-flex align-start justify-space-between ga-2">
          <span class="text-body-2 font-weight-medium text-wrap" style="line-height: 1.3">
            {{ recall.label }}
          </span>
          <v-icon v-if="recall.recallSheetUrl" size="16" color="grey" class="flex-shrink-0 mt-1">
            mdi-open-in-new
          </v-icon>
        </div>

        <span class="text-caption text-medium-emphasis mt-1">
          {{ recall.productCategory }}
        </span>

        <v-spacer />

        <div class="d-flex align-center justify-space-between mt-2">
          <v-chip size="x-small" variant="tonal" color="warning" label>
            <v-icon start size="12">mdi-alert</v-icon>
            Recall
          </v-chip>
          <span class="text-caption text-medium-emphasis">
            {{ formatDate(recall.publicationDate) }}
          </span>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, computed, type PropType } from 'vue'

export interface RecallItem {
  '@id': string
  id: number
  recallGuid: string
  sheetNumber: string
  label: string
  productCategory: string
  imageUrls: string | null
  recallSheetUrl: string | null
  publicationDate: string | null
}

export default defineComponent({
  name: 'RecallCard',
  props: {
    recall: {
      type: Object as PropType<RecallItem>,
      required: true,
    },
  },
  setup(props) {
    const imageUrl = computed((): string | null => {
      if (!props.recall.imageUrls) return null
      const first = props.recall.imageUrls.split('|')[0].trim()
      return first || null
    })

    function formatDate(iso: string | null): string {
      if (!iso) return ''
      return new Date(iso).toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
    }

    return { imageUrl, formatDate }
  },
})
</script>
